import { render } from "./SortTableBasicDataCellComponent.vue?vue&type=template&id=2d0787bc&scoped=true"
import script from "./SortTableBasicDataCellComponent.vue?vue&type=script&lang=js"
export * from "./SortTableBasicDataCellComponent.vue?vue&type=script&lang=js"

import "./SortTableBasicDataCellComponent.vue?vue&type=style&index=0&id=2d0787bc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0787bc"]])

export default __exports__